import { upperFirst } from 'es-toolkit'

import { cases } from '@subaio/utils'

import { CountryFlag } from '../CountryFlag/Default'
import { OptionLabel } from '../Fields/Shared/OptionLabel'
import { formatLocale } from './formatLocale'

type Options = {
	shortName?: boolean
	displayLocale?: string
}

const defaultCountryCodeProps = {
	size: 13,
	isRounded: true,
}

export const mapLocaleOptions = (options: Array<string>, { shortName = false, displayLocale }: Options = {}) =>
	options.map((locale) => {
		const displayName = upperFirst(formatLocale(locale, shortName, displayLocale))

		return {
			label: displayName,
			value: locale,
			render: () =>
				cases(locale.split('-')[0], {
					da: () => (
						<OptionLabel>
							<CountryFlag countryCode='DK' {...defaultCountryCodeProps} />
							<span>{displayName}</span>
						</OptionLabel>
					),
					de: () => (
						<OptionLabel>
							<CountryFlag countryCode='DE' {...defaultCountryCodeProps} />
							<span>{displayName}</span>
						</OptionLabel>
					),
					el: () => (
						<OptionLabel>
							<CountryFlag countryCode='GR' {...defaultCountryCodeProps} />
							<span>{displayName}</span>
						</OptionLabel>
					),
					en: () => (
						<OptionLabel>
							<CountryFlag countryCode='GB' {...defaultCountryCodeProps} />
							<span>{displayName}</span>
						</OptionLabel>
					),
					es: () => (
						<OptionLabel>
							<CountryFlag countryCode='ES' {...defaultCountryCodeProps} />
							<span>{displayName}</span>
						</OptionLabel>
					),
					fi: () => (
						<OptionLabel>
							<CountryFlag countryCode='FI' {...defaultCountryCodeProps} />
							<span>{displayName}</span>
						</OptionLabel>
					),
					fr: () => (
						<OptionLabel>
							<CountryFlag countryCode='FR' {...defaultCountryCodeProps} />
							<span>{displayName}</span>
						</OptionLabel>
					),
					it: () => (
						<OptionLabel>
							<CountryFlag countryCode='IT' {...defaultCountryCodeProps} />
							<span>{displayName}</span>
						</OptionLabel>
					),
					nb: () => (
						<OptionLabel>
							<CountryFlag countryCode='NO' {...defaultCountryCodeProps} />
							<span>{displayName}</span>
						</OptionLabel>
					),
					nl: () => (
						<OptionLabel>
							<CountryFlag countryCode='NL' {...defaultCountryCodeProps} />
							<span>{displayName}</span>
						</OptionLabel>
					),
					pl: () => (
						<OptionLabel>
							<CountryFlag countryCode='PL' {...defaultCountryCodeProps} />
							<span>{displayName}</span>
						</OptionLabel>
					),
					pt: () => (
						<OptionLabel>
							<CountryFlag countryCode='PT' {...defaultCountryCodeProps} />
							<span>{displayName}</span>
						</OptionLabel>
					),
					ru: () => (
						<OptionLabel>
							<CountryFlag countryCode='RU' {...defaultCountryCodeProps} />
							<span>{displayName}</span>
						</OptionLabel>
					),
					sv: () => (
						<OptionLabel>
							<CountryFlag countryCode='SE' {...defaultCountryCodeProps} />
							<span>{displayName}</span>
						</OptionLabel>
					),
				}) ?? displayName,
		}
	})
